/**
 * Caixa de entrada do atendimento -- a tela onde o agente passa o dia.
 *
 * Uma rota so, com a conversa aberta no proprio caminho (`/atendimento/:id`):
 * assim o link de uma conversa pode ser colado no chat interno e abre no lugar
 * certo, e o botao "voltar" do navegador faz o que se espera.
 */
export const nav = {
    permissao: 'atendimento.inbox:ver',
    section: 'Atendimento',
    title: 'Inbox',
    icon: 'forum',
    route: '/atendimento',
    sequence: 1,
};

export default [
    {
        path: '/atendimento',
        name: 'atendimento',
        component: () => import('./pages/InboxPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.inbox:ver' },
    },
    {
        path: '/atendimento/:id',
        name: 'atendimento-conversa',
        component: () => import('./pages/InboxPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'atendimento.inbox:ver' },
    },
];
